module.exports = __webpack_public_path__ + "img/logo_agrar.f15a5393.webp";